"use client";
import e from "./toaster.js";
import { ToasterPortalHost as t, ToasterPortalProvider as n, useToasterPortalContainer as r } from "./toaster-portal.js";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
import { createPortal as s } from "react-dom";
import { Toaster as c, toast as l } from "sonner";
//#region src/shadcn/toaster.tsx
var u = ({ visibleToasts: t = 3, closeButton: n = !0, ...l }) => {
	let u = r(), d = /* @__PURE__ */ a(c, {
		className: "toaster group",
		visibleToasts: t,
		closeButton: n,
		toastOptions: {
			closeButtonAriaLabel: "Dismiss notification",
			classNames: { toast: "border shadow-md" }
		},
		style: {
			"--normal-bg": "var(--colors-core-background)",
			"--normal-text": "var(--colors-core-foreground)",
			"--normal-border": "var(--colors-core-decorative)",
			"--toast-close-button-start": "unset",
			"--toast-close-button-end": "0",
			"--toast-close-button-transform": "translate(35%, -35%)"
		},
		...l
	});
	return /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a("style", { dangerouslySetInnerHTML: { __html: e } }), u ? s(d, u) : d] });
};
//#endregion
export { u as Toaster, t as ToasterPortalHost, n as ToasterPortalProvider, l as toast };
